export const FormatPhoneNumber = (text) => {
  const checkText = text.startsWith('62') || text.startsWith('+');
  const fixText = checkText ? text : `0${text}`;
  return text ? `${fixText}` : '-';
};
